import { httpInstance } from '../httpInstance';
import { env } from '../../config';


const getBaseUrlWithoutAdmin = () => {
  const baseUrlNewBase = env.API_URL_NEW || env.API_URL;
  return baseUrlNewBase;
};

const baseURL = getBaseUrlWithoutAdmin();
const productConfigEndpoint = '/product-service/v1/configs';

/**
 * Servicio para obtener todas las configuraciones de producto
 * @returns Promise con la lista de configuraciones
 */
export const getProductServiceConfigsService = () => {
  return httpInstance.get(productConfigEndpoint, { baseURL });
};

/**
 * Servicio para obtener una configuración específica por ID y producto
 * @param configId - ID de la configuración (ej: 'PRICING', 'BASE')
 * @param productId - ID del producto (ej: 'PAYMENT_LINKS')
 * @returns Promise con la configuración solicitada
 */
export const getProductServiceConfigByIdService = (configId: string, productId: string) => {
  return httpInstance.get(`${productConfigEndpoint}/${configId}`, {
    baseURL,
    params: { product_id: productId }
  });
};

/**
 * Servicio para crear una nueva configuración de producto
 * @param data - Datos de la configuración a crear
 * @returns Promise con la configuración creada
 */
export const createProductServiceConfigService = (data: any) => {
  return httpInstance.post(productConfigEndpoint, data, { baseURL });
};

/**
 * Servicio para actualizar una configuración de producto existente
 * Se identifica por el SK (Sort Key) del registro
 * @param sk - Sort Key del registro a actualizar (ej: 'CONFIG#PAYMENT_LINK#BASE#467834')
 * @param data - Datos de la configuración a actualizar
 * @returns Promise con la configuración actualizada
 */
export const updateProductServiceConfigService = (sk: string, data: any) => {
  return httpInstance.put(productConfigEndpoint, { ...data, sk }, { baseURL });
};

/**
 * Servicio para crear o actualizar una configuración de producto
 * Siempre usa POST; el backend determina si es creación o actualización
 * según la presencia del campo `sk` en el body.
 * @param data - Datos de la configuración (incluye sk para actualizar)
 * @returns Promise con la configuración creada/actualizada
 */
export const createOrUpdateProductServiceConfigService = (data: any) => {
  return createProductServiceConfigService(data);
};

/**
 * Servicio para eliminar una configuración de producto
 * Se identifica por el SK (Sort Key) del registro
 * @param sk - Sort Key del registro a eliminar (ej: 'CONFIG#PAYMENT_LINK#BASE#467834')
 * @returns Promise con el resultado de la eliminación
 */
export const deleteProductServiceConfigService = (sk: string) => {
  console.log('[deleteProductServiceConfigService] Deleting:', { sk });
  
  const encodedSk = encodeURIComponent(sk);
  return httpInstance.delete(`${productConfigEndpoint}/BASE?sk=${encodedSk}`, { baseURL });
};
